import { Survey } from "@velaro/velaro-component-lib";
import React from "react";

export const SurveysContext = React.createContext<{
  surveys: Survey[];
  /**
   * Accepts either a full replacement array or a functional updater (matching the underlying
   * `useState` setter in SurveysProvider) — the updater form avoids stale-closure overwrites
   * when a network round-trip (e.g. the standalone-link toggle) completes after the user has
   * kept editing.
   */
  setSurveys: (surveys: Survey[] | ((prev: Survey[]) => Survey[])) => void;
  loading: boolean;
}>({
  surveys: [],
  loading: true,
  setSurveys: () => {}
});
